
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { isBrowser } from '@/utils/runtime';

const ExitIntentPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    if (!isBrowser) return;
    
    // Check if already shown in session
    const shown = globalThis.sessionStorage?.getItem('exitPopupShown');
    if (shown) {
      setHasShown(true);
      return;
    }

    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
        globalThis.sessionStorage?.setItem('exitPopupShown', 'true');
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey && e.key === 'w') || (e.altKey && e.key === 'F4')) {
        if (!hasShown) {
          setIsVisible(true);
          setHasShown(true);
          globalThis.sessionStorage?.setItem('exitPopupShown', 'true');
        }
      }
    };

    globalThis.document.addEventListener('mouseleave', handleMouseLeave);
    globalThis.document.addEventListener('keydown', handleKeyDown);

    return () => {
      globalThis.document.removeEventListener('mouseleave', handleMouseLeave);
      globalThis.document.removeEventListener('keydown', handleKeyDown);
    };
  }, [hasShown]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isBrowser) {
      globalThis.open("https://wa.me/554797367396?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20serviços%20de%20fotografia%20para%20imóveis.", "_blank");
    }
    setIsVisible(false);
  };

  // Always return null when not visible to prevent hydration mismatch
  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999]" 
      onClick={() => setIsVisible(false)}
      suppressHydrationWarning
    >
      <div className="bg-white rounded-lg p-8 w-full max-w-md mx-4 relative" onClick={(e) => e.stopPropagation()}>
        <button 
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Fechar"
        >
          <X className="h-6 w-6" />
        </button>
        
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-toctoc-black mb-2">
            Ainda tem dúvidas?
          </h2>
          <p className="text-lg text-toctoc-gray-medium">
            Converse agora com um especialista no WhatsApp!
          </p>
        </div>

        <form 
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <input 
            name="name" 
            type="text" 
            placeholder="Nome completo" 
            required 
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
          />
          <input 
            name="email" 
            type="email" 
            placeholder="E-mail" 
            required 
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
          />
          <input 
            name="phone" 
            type="tel" 
            placeholder="Telefone" 
            required 
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
          />
          <input name="origem" type="hidden" value="Exit Intent - WhatsApp" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="box" />
          
          <button 
            type="submit" 
            className="w-full bg-toctoc-orange hover:bg-toctoc-orange/90 text-white py-3 px-4 rounded-md font-semibold transition-colors text-lg"
          >
            Fale agora mesmo!
          </button>
        </form>

        <button 
          type="button"
          onClick={() => setIsVisible(false)}
          className="w-full mt-3 text-gray-500 hover:text-gray-700 text-sm"
        >
          Não, obrigado
        </button>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
